import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import styles from './styles.scss';

const propTypes = {
  facility: PropTypes.shape({
    id: PropTypes.string.isRequired,
    address: PropTypes.shape({
      streetAddress: PropTypes.string.isRequired,
      areaAddress: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const defaultProps = {};

const FacilityAddress = ({
  facility: {
    address: {
      areaAddress,
      streetAddress,
    },
  },
}) => (
  <div className={styles.address}>
    <div>
      {streetAddress}
    </div>
    <div>
      {areaAddress}
    </div>
  </div>
);

FacilityAddress.propTypes = propTypes;
FacilityAddress.defaultProps = defaultProps;

FacilityAddress.fragments = {
  facility: gql`
    fragment FacilityAddressFacility on Facility {
      id
      address {
        areaAddress
        streetAddress
      }
    }
  `,
};

export default FacilityAddress;
